"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeeklyCoachingSubscriptionCheckoutContext = exports.isWeeklyCoachingPaymentContext = exports.WeeklyCoachingPaymentContextSchema = exports.isWeeklyCoachingSubscriptionMetadata = exports.WeeklyCoachingSubscriptionMetadataSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const language_codes_types_1 = require("./language_codes_types");
exports.WeeklyCoachingSubscriptionMetadataSchema = zod_1.z.object({
    langPairCode: language_codes_types_1.LanguagePairCodeSchema,
});
exports.isWeeklyCoachingSubscriptionMetadata = type_validation_helpers_1.getTypeValidationFunction(exports.WeeklyCoachingSubscriptionMetadataSchema);
exports.WeeklyCoachingPaymentContextSchema = zod_1.z.object({
    langPairCode: language_codes_types_1.LanguagePairCodeSchema,
    planId: zod_1.z.string(),
});
exports.isWeeklyCoachingPaymentContext = type_validation_helpers_1.getTypeValidationFunction(exports.WeeklyCoachingPaymentContextSchema);
const WeeklyCoachingSubscriptionCheckoutContextSchema = zod_1.z.object({
    subscriptionId: zod_1.z.string(),
    subscriptionMetadata: exports.WeeklyCoachingSubscriptionMetadataSchema,
});
exports.isWeeklyCoachingSubscriptionCheckoutContext = type_validation_helpers_1.getTypeValidationFunction(WeeklyCoachingSubscriptionCheckoutContextSchema);
//# sourceMappingURL=weekly_coaching_types.js.map